import "./ArticleBodyStyles.scss";
import $ from "jquery";
import { dnbComLog, dnbGetCookie, emailAddressRegularExpression, isNotUndefined, lazyLoadScriptMarketo, LogSeverity, windowOnLoadOrImmediate } from "../FunctionsCore";
const removeError = ($field) => $field
    .removeAttr("aria-describedby")
    .removeClass("form-error");
const articleBody = (articleBodyParameter) => {
    const formId = 1353;
    const leadFormSettings = articleBodyParameter.leadFormData.leadFormSettings;
    const { marketourl, munchkinId } = leadFormSettings;
    $(() => {
        const $articleRelatedContainer = $(".article_related_container");
        const $bodyContactCta = $("body").add($(".contact_cta"));
        const $content = $(".content");
        const $lightbox = $(".lightbox");
        const $lightboxNewsletter = $(".lightbox-newsletter");
        const $lightboxThankYouMessage = $(".lightbox-thank-you-msg");
        const $sideNewsletter = $(".side-newsletter");
        const $thankYouMessage = $(".thank-you-msg");
        const $window = $(window);
        const $contentFirstElement = $content.eq(0);
        const fadeSpeed = 250;
        const popLeft = 20;
        const popTop = 20;
        const addError = ($field, errorMessage) => {
            const $formErrorMessage = $('<span class="form-error-message" role="alert"></span>');
            const fieldName = $field.attr("name");
            const uniqueId = isNotUndefined(fieldName)
                ? fieldName
                : window.Math.floor(window.Math.random() * (1000 - 100) + 100);
            const areaDescribeId = `form-${uniqueId}-error`;
            $field.attr("aria-describedby", areaDescribeId);
            $formErrorMessage.attr("id", areaDescribeId);
            $field.focus();
            $field.addClass("form-error").after($formErrorMessage.clone().text(errorMessage));
        };
        const closeArticleRelatedContainer = () => $articleRelatedContainer.fadeToggle(fadeSpeed, "swing", function () {
            $(this).removeClass("active");
        });
        const validateForm = (formClass) => {
            $(".form-error-message").remove();
            const $formClass = $(`.${formClass}`);
            let error = false;
            try {
                const $inputNameEmail = $formClass.find('input[name="Email"]');
                const inputNameEmailValue = $inputNameEmail.val();
                if (typeof inputNameEmailValue !== "string") {
                    error = true;
                    addError($inputNameEmail, "Please enter email");
                }
                else if (inputNameEmailValue.match(emailAddressRegularExpression) === null) {
                    error = true;
                    addError($inputNameEmail, "The email that you entered appears to be invalid.");
                }
                else {
                    removeError($inputNameEmail);
                }
                const $selectNameCountry = $formClass.find('select[name="Country"]');
                if ($selectNameCountry.val() === "") {
                    error = true;
                    addError($selectNameCountry, "Please select country");
                }
                else {
                    removeError($selectNameCountry);
                }
                const $mktocheckboxes = $formClass.find(".mktocheckboxes");
                if ($formClass.find("input[type=checkbox]:checked").length === 0) {
                    error = true;
                    addError($mktocheckboxes, "Please select your subscription");
                }
                else {
                    removeError($mktocheckboxes);
                }
                return !error;
            }
            catch (er) {
                dnbComLog(LogSeverity.ERROR, er);
                return false;
            }
        };
        const submitForm = (formClass) => {
            const $formClass = $(`.${formClass}`);
            if (formClass === "newsletter-form") {
                if (!validateForm("newsletter-form")) {
                    return;
                }
            }
            else if (!validateForm("box-newsletter-form")) {
                return;
            }
            const $inputNameMktTrk = $formClass.find('input[name="_mkt_trk"]');
            if ($inputNameMktTrk.length > 0) {
                const mktoTrk = dnbGetCookie("_mkto_trk");
                $inputNameMktTrk.val(mktoTrk);
            }
            const $inputNameMktoReferrer = $formClass.find('input[name="_mktoReferrer"]');
            if ($inputNameMktoReferrer.length > 0) {
                $inputNameMktoReferrer.val(window.document.URL.split("?")[0]);
            }
            const formEntries = $formClass.serializeArray();
            const jsonData = {};
            for (const formEntry of formEntries) {
                jsonData[formEntry.name] = formEntry.value;
            }
            jsonData["formName"] = formClass;
            lazyLoadScriptMarketo(marketourl).addRunAfterScriptLoadCallback((mktoFormsTwo) => {
                const form = mktoFormsTwo.getForm(window.String(formId));
                form.addHiddenFields(jsonData);
                form.submit();
            });
        };
        $(".hover-article").on("mouseenter", function (mo) {
            const $this = $(this);
            const contentFirstElementWidth = $contentFirstElement.width();
            if (contentFirstElementWidth > 768) {
                const thisOffset = $this.offset();
                const contentFirstElementOffset = $contentFirstElement.offset();
                const left = thisOffset.left - contentFirstElementOffset.left + popLeft;
                if (contentFirstElementWidth > 768) {
                    // Ignore in mobile
                    const leftToUse = contentFirstElementWidth - left < 600 ? contentFirstElementWidth - 610 : left;
                    const thisHeight = $this.height();
                    // Contact panel height
                    const sectionCtaOuterHeight = $("section.cta").outerHeight();
                    const windowHeight = $window.height();
                    const dnbRelated = $this.attr("data-dnb-related");
                    // Test the cursor position against midpoint of visible screen. offset the contact panel height.
                    const $dnbRelated = $(`#${dnbRelated}`);
                    const offset = mo.pageY > window.scrollY + (windowHeight - sectionCtaOuterHeight) / 2 ? -$dnbRelated.height() - popTop : thisHeight + popTop;
                    $dnbRelated
                        .css({
                        "left": `${leftToUse}px`,
                        "top": `${thisOffset.top - contentFirstElementOffset.top + offset}px`,
                    })
                        .fadeIn(fadeSpeed, "swing", function () {
                        $(this).addClass("active");
                    });
                }
            }
        });
        const closeLightBox = () => {
            $lightbox.slideUp();
            window.setTimeout(() => $bodyContactCta.removeClass("overlay"), 500);
        };
        $("button.lightbox-close").on("click", () => {
            closeLightBox();
        });
        $window.on("click", (cl) => {
            if (!(($(cl.target).closest(".lightbox-newsletter").length > 0) || ($(cl.target).closest(".lightbox-close").length > 0))) {
                closeLightBox();
            }
        });
        $(".mktoButton").on("click", (cl) => {
            cl.preventDefault();
            submitForm("newsletter-form");
        });
        $(".lightbox-mktoButton").on("click", (cl) => {
            cl.preventDefault();
            submitForm("box-newsletter-form");
        });
        $(".article-related-popup")
            .on("click", (cl) => cl.stopPropagation())
            .on("mouseleave", closeArticleRelatedContainer);
        $window
            .on("click", closeArticleRelatedContainer)
            .on("resize", () => {
            if ($contentFirstElement.width() < 768) {
                $articleRelatedContainer.hide();
            }
        });
        windowOnLoadOrImmediate($window, () => lazyLoadScriptMarketo(marketourl).addRunAfterScriptLoadCallback((mktoFormsTwo) => {
            mktoFormsTwo.loadForm(marketourl, munchkinId, formId, (form) => {
                form.onSubmit(() => {
                    //
                });
                form.onSuccess((values, _followUpUrl) => {
                    if (values["formName"] === "newsletter-form") {
                        $sideNewsletter.hide();
                        $thankYouMessage.show();
                    }
                    else {
                        $lightboxNewsletter.hide();
                        $lightboxThankYouMessage.show();
                        $lightbox.delay(3000).fadeOut();
                        window.setTimeout(() => $bodyContactCta.removeClass("overlay"), 3500);
                    }
                    form.getFormElem().hide();
                    return false;
                });
            });
        }));
        $(".newsletter-form").parent().append(`<br><br><form style="display: none;" id="mktoForm_${formId}"></form>`);
    });
};
export { articleBody };
